// extracted by mini-css-extract-plugin
module.exports = {"SignupForm":"SignupForm--3Zqp5","Flat":"Flat--Yj7K_","Button":"Button--2CxGm"};